import { useNavigate } from 'react-router';
import { Box, Button } from '@mui/material';

const Toolbar = ({ route, text, ...props }) => {
  const navigate = useNavigate();
  const Navigate = () => {
    navigate(route);
  };
  return (
    <Box {...props}>
      <Box
        sx={{
          display: 'flex',
          justifyContent: 'flex-end'
        }}
      >
        <Button
          sx={{
            textTransform: 'none',
            transition: '.5s',
            opacity: '.9',
            '&:hover': {
              opacity: '1',
              transform: 'scale(.9)'
            }
          }}
          color="primary"
          variant="contained"
          onClick={Navigate}
        >
          {text}
        </Button>
      </Box>
    </Box>
  );
};

export default Toolbar;
